import { Badge, Table } from '@mantine/core';
import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { MouseEvent, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { companyApis } from '../../../../../shared/apis/company/apis';
import { AxiosCommonError } from '../../../../../shared/types';
import type { ICompanyData } from '../../../../../shared/types/company';
import { handleError } from '../../../../ui/err/handleError';
import { showSuccessNotification } from '../../../../ui/notification';

const tableHead = ['번호', '거래처명', '대표자명', '회사 코드', '관리자 계정생성'];

interface IPropsCompanyListTable {
  page: string;
  size: string;
  searchTypeUrl: string;
  searchWordUrl: string;
  setTotalPage: (totalPage: number) => void;
}

export default function CompanyListTable(props: IPropsCompanyListTable) {
  const { page, size, searchTypeUrl, searchWordUrl, setTotalPage } = props;
  const navigate = useNavigate();

  const sendData = {
    size: Number(size),
    page: Number(page),
    search: {
      name: searchTypeUrl === 'name' ? searchWordUrl : '',
      repName: searchTypeUrl === 'repName' ? searchWordUrl : '',
    },
  };

  const { data: companyList, refetch: refetchCompanyList } = useQuery(
    ['getCompanies', page, searchTypeUrl, searchWordUrl],
    () => companyApis.companyList(sendData),
    {
      select: (data) => data.data,
      onError: (error: AxiosError<AxiosCommonError>) => {
        handleError(error);
      },
    },
  );

  // const onClickEditModlinkAssign = (e: MouseEvent<HTMLTableCellElement>) => {
  //   e.stopPropagation();
  //   if (companyList.data === null) return;
  //   const companyName = companyList.data.find(
  //     (company: ICompanyData) => company.id === Number(e.currentTarget.id)
  //   )?.name;
  //   navigate(
  //     `/admin/management/company/assign/${Number(
  //       e.currentTarget.id
  //     )}?companyName=${companyName}`
  //   );
  // };
  const { mutate: assignMasterAccount } = useMutation(['assignMaster'], companyApis.assignMaster, {
    onSuccess: () => {
      showSuccessNotification('계정 생성 완료', '최초 관리자 계정 생성이 완료되었습니다.');
    },
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
    onMutate: () => {
      showSuccessNotification('계정 생성 이메일 발송중입니다.', '잠시만 기다려주세요.');
    },
  });

  const onClickCreateAccount = (e: MouseEvent<HTMLTableCellElement>) => {
    e.stopPropagation();
    const filter = companyList.data?.filter((company: ICompanyData) => company.id === Number(e.currentTarget.id));
    const companyId = Number(e.currentTarget.id);
    if (!filter || filter.length === 0) return;
    Swal.fire({
      icon: 'question',
      title: '계정 생성',
      text: '최초 관리자 계정을 생성하시겠습니까?',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소',
    }).then((result: { isConfirmed: boolean }) => {
      if (result.isConfirmed) {
        assignMasterAccount({
          companyId: Number(companyId),
          data: {
            email: filter[0].email,
            name: filter[0].repName,
            tel: filter[0].tel,
          },
        });
      }
    });
  };

  useEffect(() => {
    if (companyList) {
      setTotalPage(Math.ceil(companyList.total / 10));
    }
  }, [companyList]);

  return (
    <Table.ScrollContainer minWidth={1000}>
      <Table
        withTableBorder
        highlightOnHover
        style={{
          th: { textAlign: 'center' },
          td: { textAlign: 'center' },
        }}
      >
        <Table.Thead>
          <Table.Tr>
            {tableHead.map((item, index) => {
              // eslint-disable-next-line react/no-array-index-key
              return <Table.Th key={String(index)}>{item}</Table.Th>;
            })}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {companyList.data?.map((item: ICompanyData, index: number) => {
            return (
              <Table.Tr key={item.id} style={{ cursor: 'pointer' }}>
                <Table.Td>{Number(page) === 1 ? index + 1 : (Number(page) - 1) * 10 + index + 1}</Table.Td>
                <Table.Td
                  style={{
                    maxWidth: '100px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textDecoration: 'underline',
                  }}
                  onClick={() => {
                    navigate(`/admin/management/company/${item.id}`);
                  }}
                >
                  {item.name}
                </Table.Td>
                <Table.Td>{item.repName}</Table.Td>
                <Table.Td>{item.id}</Table.Td>
                <Table.Td id={String(item.id)} onClick={item.masterUser === null ? onClickCreateAccount : undefined}>
                  {item.masterUser === null ? (
                    <Badge
                      style={(theme) => ({
                        cursor: 'pointer',
                      })}
                      color="secondary.5"
                      variant="light"
                    >
                      생성하기
                    </Badge>
                  ) : (
                    <Badge
                      variant="outline"
                      style={(theme) => ({
                        border: `1px solid ${theme.colors.primary[2]}`,
                        color: theme.colors.primary[2],
                      })}
                    >
                      생성완료
                    </Badge>
                  )}
                </Table.Td>
                {/* <Table.Td>
                  <Text id={String(item.id)} size="sm">
                    {item.deviceCount}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <ActionIcon
                    id={String(item.id)}
                    variant="transparent"
                    size="sm"
                    color="primary.6"
                    onClick={onClickEditModlinkAssign}
                  >
                    <IconPencilMinus />
                  </ActionIcon>
                </Table.Td> */}
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  );
}
